import { getLogger } from '@omnia/ui/src/lib/services/logger/logger.service'
import { observable, runInAction } from 'mobx'

const logger = getLogger('OccService')

class OccService {
    public overrideSiteIdObs = observable.box<string | undefined>(undefined)

    public setOverrideSiteId(siteId: string | undefined) {
        if (this.overrideSiteIdObs.get() === siteId) return

        setTimeout(() => {
            runInAction(() => {
                logger.value.debug('Setting site id to ' + siteId)

                this.overrideSiteIdObs.set(siteId)
            })
        }, 150)
    }

    public getOverrideSiteId = () => this.overrideSiteIdObs.get()

    private excludedMemberRewards: string[] | undefined = undefined

    public setExcludedMemberRewards(rewards: string[]) {
        this.excludedMemberRewards = rewards
    }

    public getExcludedMemberRewards = () => this.excludedMemberRewards
}

export const occService = new OccService()
